import React, { createContext, useContext, useEffect, useState } from 'react';

const LanguageContext = createContext(null);

const STORAGE_KEY = 'portfolio-lang';

// 가운뎃점(·)이 줄 맨 앞으로 넘어가지 않도록 앞 글자에 붙인다
//   "개발·CI/CD" → 단어 결합자(U+2060),  "Analysis · Dev" → 줄바꿈 없는 공백
export function keepDotAttached(text) {
  return text.replace(/ ·/g, ' ·').replace(/(\S)·/g, '$1⁠·');
}

function readSavedLang() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'en' ? 'en' : 'ko';
  } catch {
    return 'ko';
  }
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(readSavedLang);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      // 저장소를 쓸 수 없는 환경(사생활 보호 모드 등)에서는 기억만 하지 않는다
    }
    document.documentElement.lang = lang;
  }, [lang]);

  // 문자열은 그대로, { ko, en } 객체는 현재 언어 값으로
  const t = (text) => keepDotAttached(typeof text === 'string' ? text : text[lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
